const title = "Softball Team Banners – Customizable Designs for Your Team";
export {title}